(function () {
  const EXCLUDE_PATHS = /^\/(?:cart|checkout)(?:\/|$)/i;
  if (EXCLUDE_PATHS.test(location.pathname)) return;

  const state = { isActive: false, searchBtn: null, trackingHandler: null };
  const headerTop = document.querySelector('.header-top-row');
  if (!headerTop) return;

  const activate = () => {
    if (state.isActive) return;
    state.isActive = true;
    document.documentElement.classList.add('cw-cl-scrolled');

    const drawerWrap = headerTop.querySelector('.header-drawer-btn-wrapper');
    if (drawerWrap && !headerTop.querySelector('.header-search-toggle-btn')) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'header-search-toggle-btn';
      btn.setAttribute('aria-label', 'Open search');
      btn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <g clip-path="url(#clip0_55_51)">
            <path d="M23.7068 22.2929L16.8818 15.468C18.2038 13.835 18.9998 11.76 18.9998 9.50008C18.9998 4.26213 14.7378 0.000152588 9.49988 0.000152588C4.26193 0.000152588 0 4.26208 0 9.50003C0 14.738 4.26197 19 9.49992 19C11.7599 19 13.8349 18.204 15.4678 16.882L22.2928 23.7069C22.4878 23.9019 22.7438 23.9999 22.9998 23.9999C23.2558 23.9999 23.5118 23.9019 23.7068 23.7069C24.0978 23.3159 24.0978 22.6839 23.7068 22.2929ZM9.49992 17C5.36395 17 2 13.636 2 9.50003C2 5.36405 5.36395 2.0001 9.49992 2.0001C13.6359 2.0001 16.9998 5.36405 16.9998 9.50003C16.9998 13.636 13.6359 17 9.49992 17Z" fill="#F0515F"/>
          </g>
          <defs><clipPath id="clip0_55_51"><rect width="24" height="24" fill="white"/></clipPath></defs>
        </svg>
      `;
      drawerWrap.insertAdjacentElement('afterend', btn);
      state.searchBtn = btn;

      btn.addEventListener('click', () => {
        const form = document.querySelector('.header-search-block');
        const input = document.querySelector('#boost-sd__search-widget-init-input-1');
        if (!form || !input) return;
        document.documentElement.classList.add('is-search-active');
        requestAnimationFrame(() => {
          ['pointerdown','mousedown','mouseup','click'].forEach(type => {
            input.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
          });
          input.dispatchEvent(new Event('focusin', { bubbles: true }));
          input.focus();
        });
        setTimeout(() => {
          ['pointerdown','mousedown','mouseup','click'].forEach(type => {
            input.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
          });
          input.dispatchEvent(new Event('focusin', { bubbles: true }));
          input.focus();
        }, 50);
      });
    }

    const overlayClasses = ['boost-sd__search-opening', 'boost-sd__g-no-scroll'];
    const isOverlayActive = () => overlayClasses.some(c => document.body.classList.contains(c));
    const stickySelector = '.cw-cl-sticky .shopify-section-group-header-group.section-header';

    state.trackingHandler = function (e) {
      const stickyEl = e.target.closest(stickySelector);
      if (!stickyEl || isOverlayActive()) return;
      window._conv_q = window._conv_q || [];
      window._conv_q.push(["triggerConversion", "1004105046"]);
    };
    document.addEventListener('click', state.trackingHandler, { capture: true, passive: true });
  };

  const deactivate = () => {
    if (!state.isActive) return;
    state.isActive = false;
    document.documentElement.classList.remove('cw-cl-scrolled', 'is-search-active');
    if (state.searchBtn && state.searchBtn.parentNode) state.searchBtn.remove();
    state.searchBtn = null;
    if (state.trackingHandler) document.removeEventListener('click', state.trackingHandler, { capture: true });
    state.trackingHandler = null;
  };

  let ticking = false;
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const atTop = window.scrollY <= 0;
        atTop ? deactivate() : activate();
        ticking = false;
      });
      ticking = true;
    }
  };

  const onLoad = () => {
    if (window.scrollY > 0) activate();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', onLoad);
  document.addEventListener('DOMContentLoaded', onLoad);
})();
